export const releaseNotes = [
  {
    version: 'v3.1',
    date: '2026-03-17',
    added: [
      'Implemented Google authentication to provide a more secure and consistent sign-in experience.',
      'Added a personalized user dashboard. Users can select their initials in the left sidebar to view assigned tasks, reminders, and summary information in one place.',
      'Added email summary reports. Users can manually send a report from the top-right action button, and automated monthly summaries are emailed on the 1st of each month at 8:00 AM PST.',

    ],
    fixed: [
      'Resolved dark theme display issues so the theme applies more consistently across all pages.',
      'Improved backend SQL security controls to better protect application data and user sessions.',
    ],
  },
  {
    version: 'v3.2',
    date: '2026-03-20',
    added: [
      'Moved the map into a dedicated page to improve navigation and provide more space for location-based workflows.',
      'Added map filters to help users narrow locations by relevant site and support attributes.',
      'Added saved theme preferences so each user keeps their selected light or dark mode between sessions.',
      'Updated employee filtering so it automatically defaults to the currently signed-in user where appropriate.',
      'Added the ability to create a new action type while configuring standard and premium support plan actions.',
      'Added versioned release notes so users can review recent product changes directly in the application.',
      
    ],
    fixed: [
      'Fixed a SQL issue that could create a blank company record when adding a new location.',
      'Corrected SQL primary key and foreign key relationships to improve data integrity across related tables.',
    ],
  },
   {
    version: 'v3.3',
    date: '2026-04-08',
    added: [
      'Added a default grey map icon for non-customer locations that do not have an assigned support status.',
      'Added the LocationSupportHistory SQL table to track support status changes and expired support plans.',
      'Added a support history section on the dashboard so recent support changes are visible from the main page.',
      'Added a daily midnight background process that automatically downgrades expired Standard or Premium support plans back to Basic after the support end date has passed.',
      'Added 200 km and 300 km nearby-location options to expand distance-based location searches.'    
    ],
    fixed: [
      'No major defect fixes were included in this release.'
      
    ],
  },
  {
    version: 'v3.4',
    date: '2026-04-10',
    added: [
      'Added a Point to Map column to the dashboard summary table. Selecting it opens the map page with the selected location centered and focused.',
      'Updated the dashboard calendar to highlight support plans that started during the current year using green indicators.',
      'Added a trip planner to the map page when nearby locations are selected.',
      'Added trip planner reports, including the ability to email the report to yourself.',
      'Added nearby airport information to the nearby-locations workflow. The map now includes the closest medium and large airports when available.'

           
    ],
    fixed: [
      'No major defect fixes were included in this release.',
      
    ],
  },
   {
    version: 'v3.5',
    date: '2026-07-17',
    added: [
      'Separated the company and division filters into independent controls to make location filtering more precise.',
      'Saved the Show Only Late Actions and Show Completed Actions preferences so each user keeps their selected report view between sessions.',
      'Added edit and delete actions to the reports page, allowing report records to be managed without leaving the page.',
      'Added a Remote Access page for tracking customer VPN details, web connection links, credentials, MFA ownership, and division-specific computer access information.',
      'Added add, edit, delete, copy, open-link, password visibility, search, and export tools for remote access records.',
      'Added credential health badges to the Remote Access tables, including MFA, Web Portal, Password Missing, Mill Approval, Notes, and other missing-field indicators.',
      'Added a company summary panel on the Remote Access page showing VPN entries, divisions, computers, and records requiring review.',
      'Added an automatic password-hiding safeguard. When Show Passwords is enabled, passwords are hidden again after 60 seconds.',
      'Added a Needs Review filter to quickly identify incomplete remote access and division computer records.',
      'Added per-user favorite companies to the Remote Access company filter so frequently used companies appear first for each signed-in user.',
      'Updated the Add VPN Info and Add Computer dialogs to automatically preselect and filter to the company selected in the main Remote Access company filter.'
      
      

           
    ],
    fixed: [
      'Improved several UI workflows and data entry controls while adding the remote access feature set.',
      
    ],
  },
];

export const currentVersion = releaseNotes[releaseNotes.length - 1]?.version || 'v0.0';
